import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { markDailySheetShown, shouldShowDailySheet } from "@/daily/promo";
import { dt } from "@/daily/strings";
import { trackEvent } from "@/utils/analytics";
import "./daily.css";
import { ArrowIcon } from "./icons";
import { Sheet } from "./Sheet";

// How long the classic game's score has the screen to itself first (ms).
const RISES_AFTER = 1200;
const FROM = "classic_end_screen";

// Offers Daily Service at the end of a classic game: a sheet on a phone, a
// dialog on desktop. Only for players who have not played today's puzzle,
// and at most once a day.
// Whether the sheet is up. Kept outside the component because the classic
// end screen is mounted more than once as its dialog opens, and the sheet
// must not vanish or come back when that happens.
let showing = false;

export const DailyPromoSheet = () => {
  const [open, setOpen] = useState(showing);

  useEffect(() => {
    if (showing || !shouldShowDailySheet()) return;
    const timer = window.setTimeout(() => {
      markDailySheetShown();
      showing = true;
      setOpen(true);
      trackEvent("daily_promo_viewed", { from: FROM });
    }, RISES_AFTER);
    return () => window.clearTimeout(timer);
  }, []);

  const onClose = () => {
    showing = false;
    setOpen(false);
  };

  if (!open) return null;

  return (
    <Sheet
      labelledBy="ds-promo-title"
      className="ds-promo"
      onClose={onClose}
    >
      {(close) => (
        <>
          <span className="ds-eyebrow ds-eyebrow--red ds-help__eyebrow">
            {dt("promoEyebrow")}
          </span>
          <h1 id="ds-promo-title" className="ds-help__title">
            Daily Service
          </h1>
          <p className="ds-promo__text">
            {dt("promoText")}
          </p>
          <hr className="ds-help__rule" />
          <Link
            to="/daily"
            className="ds-button ds-button--red ds-promo__button"
            onClick={() => {
              showing = false;
              trackEvent("daily_promo_clicked", { from: FROM });
            }}
          >
            {dt("promoPlay")}
            <ArrowIcon size={18} />
          </Link>
          <button
            type="button"
            className="ds-promo__later"
            onClick={() => {
              trackEvent("daily_promo_dismissed", { from: FROM });
              close();
            }}
          >
            {dt("later")}
          </button>
        </>
      )}
    </Sheet>
  );
};
